import { sha256 } from 'js-sha256'

const INVALID_OBJ_TYPE = 0
const ALG_DES = 1
const ALG_3DES_112 = 2
const ALG_3DES_168 = 3
const ALG_RSA_512 = 4
const ALG_RSA_1024 = 5
const ALG_RSA_2048 = 6
const ALG_AES_128 = 7
const ALG_AES_192 = 8
const ALG_AES_256 = 9
const ALG_ARC4 = 10
const ALG_RSA_4096 = 11
const ALG_OBJ_BLOB = 12
const ALG_OBJ_BLOB_X509 = 13
const ALG_OBJ_BLOB_PKCS7 = 14
const ALG_OBJ_BLOB_CRL = 15
const ALG_OBJ_BLOB_HOTP = 16
const ALG_ECC_SECP112R1 = 18
const ALG_ECC_SECP112R2 = 19
const ALG_ECC_SECP128R1 = 20
const ALG_ECC_SECP128R2 = 21
const ALG_ECC_SECP160K1 = 22
const ALG_ECC_SECP160R1 = 23
const ALG_ECC_SECP160R2 = 24
const ALG_ECC_SECP192K1 = 25
const ALG_ECC_SECP192R1 = 26
const ALG_ECC_SECP224K1 = 27
const ALG_ECC_SECP224R1 = 28
const ALG_ECC_SECP256K1 = 29
const ALG_ECC_SECP256R1 = 30
const ALG_ECC_SECP384R1 = 31
const ALG_ECC_SECP521R1 = 32
const ALG_ECC_X9_62_PRIME192V2 = 33
const ALG_ECC_X9_62_PRIME192V3 = 34
const ALG_ECC_X9_62_PRIME239V1 = 35
const ALG_ECC_X9_62_PRIME239V2 = 36
const ALG_ECC_X9_62_PRIME239V3 = 37
const ALG_ECC_BRAINPOOL_P160R1 = 38
const ALG_ECC_BRAINPOOL_P160T1 = 39
const ALG_ECC_BRAINPOOL_P192R1 = 40
const ALG_ECC_BRAINPOOL_P192T1 = 41
const ALG_ECC_BRAINPOOL_P224R1 = 42
const ALG_ECC_BRAINPOOL_P224T1 = 43
const ALG_ECC_BRAINPOOL_P256R1 = 44
const ALG_ECC_BRAINPOOL_P256T1 = 45
const ALG_ECC_BRAINPOOL_P320R1 = 46
const ALG_ECC_BRAINPOOL_P320T1 = 47
const ALG_ECC_BRAINPOOL_P384R1 = 48
const ALG_ECC_BRAINPOOL_P384T1 = 49
const ALG_ECC_BRAINPOOL_P512R1 = 50
const ALG_ECC_BRAINPOOL_P512T1 = 51
const ALG_ARC5 = 89
const ALG_MAP_2_OBJ = 90
const ALG_DESX = 91
const ALG_HMAC_MD5 = 92
const ALG_HMAC_SHA1 = 93
const ALG_HMAC_SHA2_256 = 94
const ALG_HMAC_SHA2_384 = 95
const ALG_HMAC_SHA2_512 = 96
const ALG_HMAC_SHA2_224 = 97
const ALG_HMAC_SHA3_224 = 98
const ALG_HMAC_SHA3_256 = 99
const ALG_HMAC_SHA3_384 = 100
const ALG_HMAC_SHA3_512 = 101
const ALG_PKCS11_MAP = 120
const ALG_RSA_1152 = 121
const ALG_RSA_1408 = 122
const ALG_RSA_1984 = 123
const ALG_RSA_8192 = 124
const ALG_EXT_MAP_2_OBJ = 125
const ALG_RSA_2304 = 126
const ALG_RSA_2560 = 127
const ALG_RSA_2816 = 128
const ALG_RSA_3072 = 129
const ALG_RSA_1976 = 130
const ALG_RSA_1536 = 131

const ALG_DSA_2048 = 150
const ALG_DSA_3072 = 151

const ALG_DH_RFC5114_2048 = 152
const ALG_DH_RFC7919_2048 = 153
const ALG_DH_RFC7919_3072 = 154

const ALG_OBJ_CSP = 193

const ALG_ECC_ED25519 = 201
const ALG_ECC_ED448 = 202
const ALG_ECC_X25519 = 203
const ALG_ECC_X448 = 204

const ALG_OBJ_PUBKEY_BLOB = 350
const ALG_OBJ_PUBKEY_RSA_BLOB = 351
const ALG_OBJ_PUBKEY_ECC_BLOB = 352
const ALG_OBJ_PUBKEY_SPKI_RSA_BLOB = 353
const ALG_OBJ_PUBKEY_ECC_ED_BLOB = 354
const ALG_OBJ_PUBKEY_ECC_X_BLOB = 355
const ALG_OBJ_PUBKEY_DSA_BLOB = 356
const ALG_OBJ_PUBKEY_DH_BLOB = 357

const SL_STATE_UNKNOWN = 0
const SL_STATE_PRE_ACTIVE = 1
const SL_STATE_ACTIVE = 2
const SL_STATE_DEACTIVATED = 3
const SL_STATE_COMPROMISED = 4
const SL_STATE_DESTROYED = 5
const SL_STATE_DESTROYED_C = 6

const MSBO_OP_BLOCK = 255
const MSBO_OP_UNBLOCK = 0
const MSBO_OP_STATUS = 254

const ALG_BLKC_BTC_MINI_KEY = 1771
const ALG_BLKC_BIP32_SXPRIV = 1772
const ALG_BLKC_BIP39_SXPRIV = 1773
const ALG_BLKC_BIP32_XPRIV = 1774
// eslint-disable-next-line camelcase
const ALG_BLKC_BIP32_Ed25519_XPRIV = 1775

const familyOthers = [
  ALG_OBJ_BLOB,
  ALG_OBJ_BLOB_X509,
  ALG_OBJ_BLOB_PKCS7,
  ALG_OBJ_BLOB_CRL,
  ALG_OBJ_BLOB_HOTP
]
const asymmetricRanges = [
  [18, 51],
  [4, 6],
  [11, 11],
  [121, 124],
  [126, 129],
  [201, 204],
  [350, 353]
]

export const state = {
  SL_ALG_MAPPER: {
    [INVALID_OBJ_TYPE]: {
      id: '-',
      type: '',
      size: ''
    },
    [ALG_DES]: {
      id: 'des',
      type: 'DES',
      size: '56'
    },
    [ALG_3DES_112]: {
      id: '3des112',
      type: '3DES',
      size: '112'
    },
    [ALG_3DES_168]: {
      id: '3des168',
      type: '3DES',
      size: '168'
    },
    [ALG_RSA_512]: {
      id: 'rsa512',
      type: 'RSA',
      size: '512'
    },
    [ALG_RSA_1024]: {
      id: 'rsa1024',
      type: 'RSA',
      size: '1024'
    },
    [ALG_RSA_2048]: {
      id: 'rsa2048',
      type: 'RSA',
      size: '2048'
    },
    [ALG_AES_128]: {
      id: 'aes128',
      type: 'AES',
      size: '128'
    },
    [ALG_AES_192]: {
      id: 'aes192',
      type: 'AES',
      size: '192'
    },
    [ALG_AES_256]: {
      id: 'aes256',
      type: 'AES',
      size: '256'
    },
    [ALG_ARC4]: {
      id: 'arc4',
      type: 'ARC4',
      size: '128'
    },
    [ALG_ARC5]: {
      id: 'arc5',
      type: 'ARC5',
      size: '128'
    },
    [ALG_RSA_4096]: {
      id: 'rsa4096',
      type: 'RSA',
      size: '4096'
    },
    [ALG_OBJ_BLOB]: {
      id: 'blob',
      type: 'BLOB',
      size: ''
    },
    [ALG_OBJ_BLOB_X509]: {
      id: 'x.509',
      type: 'x.509',
      size: ''
    },
    [ALG_OBJ_BLOB_PKCS7]: {
      id: 'pkcs7',
      type: 'PKCS#7',
      size: ''
    },
    [ALG_OBJ_BLOB_CRL]: {
      id: 'crl',
      type: 'CRL',
      size: ''
    },
    [ALG_OBJ_BLOB_HOTP]: {
      id: 'hotp',
      type: 'HOTP',
      size: ''
    },
    [ALG_ECC_SECP112R1]: {
      id: 'secp112r1',
      type: 'SECP',
      size: '112'
    },
    [ALG_ECC_SECP112R2]: {
      id: 'secp112r2',
      type: 'SECP',
      size: '112'
    },
    [ALG_ECC_SECP128R1]: {
      id: 'secp128r1',
      type: 'SECP',
      size: '128'
    },
    [ALG_ECC_SECP128R2]: {
      id: 'secp128r2',
      type: 'SECP',
      size: '128'
    },
    [ALG_ECC_SECP160K1]: {
      id: 'secp160k1',
      type: 'SECP',
      size: '160'
    },
    [ALG_ECC_SECP160R1]: {
      id: 'secp160r1',
      type: 'SECP',
      size: '160'
    },
    [ALG_ECC_SECP160R2]: {
      id: 'secp160r2',
      type: 'SECP',
      size: '160'
    },
    [ALG_ECC_SECP192K1]: {
      id: 'secp192k1',
      type: 'SECP',
      size: '192'
    },
    [ALG_ECC_SECP192R1]: {
      id: 'secp192r1',
      type: 'SECP',
      size: '192'
    },
    [ALG_ECC_SECP224K1]: {
      id: 'secp224k1',
      type: 'SECP',
      size: '224'
    },
    [ALG_ECC_SECP224R1]: {
      id: 'secp224r1',
      type: 'SECP',
      size: '224'
    },
    [ALG_ECC_SECP256K1]: {
      id: 'secp256k1',
      type: 'SECP',
      size: '256'
    },
    [ALG_ECC_SECP256R1]: {
      id: 'secp256r1',
      type: 'SECP',
      size: '256'
    },
    [ALG_ECC_SECP384R1]: {
      id: 'secp384r1',
      type: 'SECP',
      size: '384'
    },
    [ALG_ECC_SECP521R1]: {
      id: 'secp521r1',
      type: 'SECP',
      size: '521'
    },
    [ALG_ECC_X9_62_PRIME192V2]: {
      id: 'x962p192v2',
      type: 'X9.62',
      size: '192'
    },
    [ALG_ECC_X9_62_PRIME192V3]: {
      id: 'x962p192v3',
      type: 'X9.62',
      size: '192'
    },
    [ALG_ECC_X9_62_PRIME239V1]: {
      id: 'x962p239v1',
      type: 'X9.62',
      size: '239'
    },
    [ALG_ECC_X9_62_PRIME239V2]: {
      id: 'x962p239v2',
      type: 'X9.62',
      size: '239'
    },
    [ALG_ECC_X9_62_PRIME239V3]: {
      id: 'x962p239v3',
      type: 'X9.62',
      size: '239'
    },
    [ALG_ECC_BRAINPOOL_P160R1]: {
      id: 'bp_p160r1',
      type: 'BrainPool',
      size: '160',
      subtype: ['r1']
    },
    [ALG_ECC_BRAINPOOL_P160T1]: {
      id: 'bp_p160t1',
      type: 'BrainPool',
      size: '160',
      subtype: ['t1']
    },
    [ALG_ECC_BRAINPOOL_P192R1]: {
      id: 'bp_p192r1',
      type: 'BrainPool',
      size: '192',
      subtype: ['r1']
    },
    [ALG_ECC_BRAINPOOL_P192T1]: {
      id: 'bp_p192t1',
      type: 'BrainPool',
      size: '192',
      subtype: ['t1']
    },
    [ALG_ECC_BRAINPOOL_P224R1]: {
      id: 'bp_p224r1',
      type: 'BrainPool',
      size: '224',
      subtype: ['r1']
    },
    [ALG_ECC_BRAINPOOL_P224T1]: {
      id: 'bp_p224t1',
      type: 'BrainPool',
      size: '224',
      subtype: ['t1']
    },
    [ALG_ECC_BRAINPOOL_P256R1]: {
      id: 'bp_p256r1',
      type: 'BrainPool',
      size: '256',
      subtype: ['r1']
    },
    [ALG_ECC_BRAINPOOL_P256T1]: {
      id: 'bp_p256t1',
      type: 'BrainPool',
      size: '256',
      subtype: ['t1']
    },
    [ALG_ECC_BRAINPOOL_P320R1]: {
      id: 'bp_p320r1',
      type: 'BrainPool',
      size: '320',
      subtype: ['r1']
    },
    [ALG_ECC_BRAINPOOL_P320T1]: {
      id: 'bp_p320t1',
      type: 'BrainPool',
      size: '320',
      subtype: ['t1']
    },
    [ALG_ECC_BRAINPOOL_P384R1]: {
      id: 'bp_p384r1',
      type: 'BrainPool',
      size: '384',
      subtype: ['r1']
    },
    [ALG_ECC_BRAINPOOL_P384T1]: {
      id: 'bp_p384t1',
      type: 'BrainPool',
      size: '384',
      subtype: ['t1']
    },
    [ALG_ECC_BRAINPOOL_P512R1]: {
      id: 'bp_p512r1',
      type: 'BrainPool',
      size: '512',
      subtype: ['r1']
    },
    [ALG_ECC_BRAINPOOL_P512T1]: {
      id: 'bp_p512t1',
      type: 'BrainPool',
      size: '512',
      subtype: ['t1']
    },
    [ALG_MAP_2_OBJ]: {
      id: 'map',
      type: 'MAP',
      size: ''
    },
    [ALG_DESX]: {
      id: 'desx',
      type: 'DESX',
      size: '184'
    },
    [ALG_HMAC_MD5]: {
      id: 'hmacmd5',
      type: 'HMAC MD5',
      size: '128'
    },
    [ALG_HMAC_SHA1]: {
      id: 'hmacsha1',
      type: 'HMAC SHA1',
      size: '160'
    },
    [ALG_HMAC_SHA2_256]: {
      id: 'hmacsha256',
      type: 'HMAC SHA2',
      size: '256'
    },
    [ALG_HMAC_SHA2_384]: {
      id: 'hmacsha384',
      type: 'HMAC SHA2',
      size: '384'
    },
    [ALG_HMAC_SHA2_512]: {
      id: 'hmacsha512',
      type: 'HMAC SHA2',
      size: '512'
    },
    [ALG_HMAC_SHA2_224]: {
      id: 'hmacsha224',
      type: 'HMAC SHA2',
      size: '224'
    },
    [ALG_HMAC_SHA3_224]: {
      id: 'hmacsha_3_224',
      type: 'HMAC SHA3',
      size: '224'
    },
    [ALG_HMAC_SHA3_256]: {
      id: 'hmacsha_3_256',
      type: 'HMAC SHA3',
      size: '256'
    },
    [ALG_HMAC_SHA3_384]: {
      id: 'hmacsha_3_384',
      type: 'HMAC SHA3',
      size: '384'
    },
    [ALG_HMAC_SHA3_512]: {
      id: 'hmacsha_3_512',
      type: 'HMAC SHA3',
      size: '512'
    },
    [ALG_PKCS11_MAP]: {
      id: 'p11map',
      type: 'PKCS#11 Map',
      size: ''
    },
    [ALG_RSA_1152]: {
      id: 'rsa1152',
      type: 'RSA',
      size: '1152'
    },
    [ALG_RSA_1408]: {
      id: 'rsa1408',
      type: 'RSA',
      size: '1408'
    },
    [ALG_RSA_1984]: {
      id: 'rsa1984',
      type: 'RSA',
      size: '1984'
    },
    [ALG_RSA_8192]: {
      id: 'rsa8192',
      type: 'RSA',
      size: '8192'
    },
    [ALG_EXT_MAP_2_OBJ]: {
      id: 'extmap',
      type: 'EXT MAP',
      size: ''
    },
    [ALG_RSA_2304]: {
      id: 'rsa2304',
      type: 'RSA',
      size: '2304'
    },
    [ALG_RSA_2560]: {
      id: 'rsa2560',
      type: 'RSA',
      size: '2560'
    },
    [ALG_RSA_2816]: {
      id: 'rsa2816',
      type: 'RSA',
      size: '2816'
    },
    [ALG_RSA_3072]: {
      id: 'rsa3072',
      type: 'RSA',
      size: '3072'
    },
    [ALG_RSA_1976]: {
      id: 'rsa1976',
      type: 'RSA',
      size: '1976'
    },
    [ALG_RSA_1536]: {
      id: 'rsa1536',
      type: 'RSA',
      size: '1536'
    },
    [ALG_DSA_2048]: {
      id: 'dsa2048',
      type: 'DSA',
      size: '2048'
    },
    [ALG_DSA_3072]: {
      id: 'dsa3072',
      type: 'DSA',
      size: '3072'
    },
    [ALG_DH_RFC5114_2048]: {
      id: 'dh_rfc5114_2048',
      type: 'DH RFC5114',
      size: '2048'
    },
    [ALG_DH_RFC7919_2048]: {
      id: 'dh_rfc7919_2048',
      type: 'DH RFC7919',
      size: '3072'
    },
    [ALG_DH_RFC7919_3072]: {
      id: 'dh_rfc7919_3072',
      type: 'DH RFC7919',
      size: '3072'
    },
    [ALG_ECC_ED25519]: {
      id: 'ed25519',
      type: 'Edwards',
      size: '256'
    },
    [ALG_ECC_ED448]: {
      id: 'ed448',
      type: 'Edwards',
      size: '448'
    },
    [ALG_ECC_X25519]: {
      id: 'x25519',
      type: 'Edwards-x',
      size: '256'
    },
    [ALG_ECC_X448]: {
      id: 'x448',
      type: 'Edwards-x',
      size: '448'
    },
    [ALG_OBJ_PUBKEY_BLOB]: {
      id: 'pubkey',
      type: 'PUB KEY',
      size: ''
    },
    [ALG_OBJ_PUBKEY_RSA_BLOB]: {
      id: 'rsapubkey',
      type: 'RSA PUB KEY',
      size: ''
    },
    [ALG_OBJ_PUBKEY_ECC_BLOB]: {
      id: 'eccpubkey',
      type: 'ECC PUB KEY',
      size: ''
    },
    [ALG_OBJ_PUBKEY_SPKI_RSA_BLOB]: {
      id: 'rsaspki',
      type: 'RSA SPKI',
      size: ''
    },
    [ALG_OBJ_PUBKEY_ECC_ED_BLOB]: {
      id: 'eddsapubkey',
      type: 'EDDSA PUB KEY',
      size: ''
    },
    [ALG_OBJ_PUBKEY_ECC_X_BLOB]: {
      id: 'xecdhpubkey',
      type: 'XECDH PUB KEY',
      size: ''
    },
    [ALG_OBJ_PUBKEY_DSA_BLOB]: {
      id: 'dsapubkey',
      type: 'DSA PUB KEY',
      size: ''
    },
    [ALG_OBJ_PUBKEY_DH_BLOB]: {
      id: 'dhpubkey',
      type: 'DH PUB KEY',
      size: ''
    },
    [ALG_BLKC_BTC_MINI_KEY]: {
      id: 'btcminikey',
      type: 'BTC MINI KEY',
      size: ''
    },
    [ALG_BLKC_BIP32_SXPRIV]: {
      id: 'bip32sxpriv',
      type: 'BIP32 SXPRIV',
      size: ''
    },
    [ALG_BLKC_BIP39_SXPRIV]: {
      id: 'bip39sxpriv',
      type: 'BIP39 SXPRIV',
      size: ''
    },
    [ALG_BLKC_BIP32_XPRIV]: {
      id: 'bip32xpriv',
      type: 'BIP32 XPRIV',
      size: ''
    },
    // eslint-disable-next-line camelcase
    [ALG_BLKC_BIP32_Ed25519_XPRIV]: {
      id: 'bip32ed25519xpriv',
      type: 'BIP32 Edwards XPRIV',
      size: '256'
    },
    [ALG_OBJ_CSP]: {
      id: 'csp',
      type: 'CSP',
      size: ''
    }
  },
  SL_STATE_MAPPER: {
    [SL_STATE_UNKNOWN]: 'unknown',
    [SL_STATE_PRE_ACTIVE]: 'pre-active',
    [SL_STATE_ACTIVE]: 'active',
    [SL_STATE_DEACTIVATED]: 'deactivated',
    [SL_STATE_COMPROMISED]: 'compromised',
    [SL_STATE_DESTROYED]: 'destroyed',
    [SL_STATE_DESTROYED_C]: 'destroyed-c'
  },
  meta: {
    name: null,
    attr: 0,
    type: null
  },
  currentName: null,
  blocked: false,
  CKA_DERIVE: false,
  CKA_WRAP: false,
  CKA_UNWRAP: false,
  CKA_SIGN: false,
  CKA_VERIFY: false,
  CKA_ENCRYPT: false,
  CKA_DECRYPT: false,
  CKA_SIGN_RECOVER: false,
  CKA_VERIFY_RECOVER: false,
  CKA_TRUSTED: false,
  CKA_WRAP_WITH_TRUSTED: false,

  CKA_SUBJECT: null,

  CKA_OBJECT_ID: null,
  CKA_ID: null,
  CKA_LABEL: null,
  CKA_APPLICATION: null,
  CKA_JMIDP_SEC_DOMAIN: null,
  CKA_CERT_CATEGORY: null,
  CKA_KEY_GEN_MECHANISM: null,
  HSM_ASSOCIATE: null,
  HSM_OBJ_PVALUE: null
}

export const getters = {
  getOptions: () => {
    return {
      symmetric: [
        {
          name: 'DES',
          value: 'DES',
          options: [
            {
              name: '56 bits',
              value: ALG_DES
            }
          ]
        },
        {
          name: '3DES',
          value: '3DES',
          options: [
            {
              name: '112 bits',
              value: ALG_3DES_112
            },
            {
              name: '168 bits',
              value: ALG_3DES_168
            }
          ]
        },
        {
          name: 'DESX',
          value: 'DESX',
          options: [
            {
              name: '184 bits',
              value: ALG_DESX
            }
          ]
        },
        {
          name: 'AES',
          value: 'AES',
          options: [
            {
              name: '128 bits',
              value: ALG_AES_128
            },
            {
              name: '192 bits',
              value: ALG_AES_192
            },
            {
              name: '256 bits',
              value: ALG_AES_256
            }
          ]
        },
        {
          name: 'ARC4',
          value: 'ARC4',
          options: [
            {
              name: '128 bits',
              value: ALG_ARC4
            }
          ]
        },
        {
          name: 'ARC5',
          value: 'ARC5',
          options: [
            {
              name: '128 bits',
              value: ALG_ARC5
            }
          ]
        },
        {
          name: 'HMAC',
          value: 'HMAC',
          options: [
            {
              name: 'MD5',
              value: ALG_HMAC_MD5
            },
            {
              name: 'SHA1',
              value: ALG_HMAC_SHA1
            },
            {
              name: 'SHA-256',
              value: ALG_HMAC_SHA2_256
            },
            {
              name: 'SHA-384',
              value: ALG_HMAC_SHA2_384
            },
            {
              name: 'SHA-512',
              value: ALG_HMAC_SHA2_512
            },
            {
              name: 'SHA-224',
              value: ALG_HMAC_SHA2_224
            },
            {
              name: 'SHA-3-224',
              value: ALG_HMAC_SHA3_224
            },
            {
              name: 'SHA-3-256',
              value: ALG_HMAC_SHA3_256
            },
            {
              name: 'SHA-3-384',
              value: ALG_HMAC_SHA3_384
            },
            {
              name: 'SHA-3-512',
              value: ALG_HMAC_SHA3_512
            }
          ]
        }
      ],
      asymmetric: [
        // {
        //   name: 'DH',
        //   value: 'DH',
        //   options: [
        //     {
        //       name: '2048 bits',
        //       value: '2048 bits',
        //       options: [
        //         {
        //           name: 'RFC7919',
        //           value: ALG_DH_RFC7919_2048
        //         },
        //         {
        //           name: 'RFC5114',
        //           value: ALG_DH_RFC5114_2048
        //         }
        //       ]
        //     },
        //     {
        //       name: '3072 bits',
        //       value: ALG_DH_RFC7919_3072
        //     }
        //   ]
        // },
        {
          name: 'DSA',
          value: 'DSA',
          options: [
            {
              name: '2048 bits',
              value: ALG_DSA_2048
            },
            {
              name: '3072 bits',
              value: ALG_DSA_3072
            }
          ]
        },
        {
          name: 'RSA',
          value: 'RSA',
          options: [
            {
              name: '512 bits',
              value: ALG_RSA_512
            },
            {
              name: '1024 bits',
              value: ALG_RSA_1024
            },
            {
              name: '1152 bits',
              value: ALG_RSA_1152
            },
            {
              name: '1408 bits',
              value: ALG_RSA_1408
            },
            {
              name: '1536 bits',
              value: ALG_RSA_1536
            },
            {
              name: '1976 bits',
              value: ALG_RSA_1976
            },
            {
              name: '1984 bits',
              value: ALG_RSA_1984
            },
            {
              name: '2048 bits',
              value: ALG_RSA_2048
            },
            {
              name: '2304 bits',
              value: ALG_RSA_2304
            },
            {
              name: '2560 bits',
              value: ALG_RSA_2560
            },
            {
              name: '2816 bits',
              value: ALG_RSA_2816
            },
            {
              name: '3072 bits',
              value: ALG_RSA_3072
            },
            {
              name: '4096 bits',
              value: ALG_RSA_4096
            },
            {
              name: '8192 bits',
              value: ALG_RSA_8192
            }
          ]
        },
        {
          name: 'ECC',
          value: 'ECC',
          options: [
            {
              name: 'SecG Random',
              value: 'SecG Random',
              options: [
                {
                  name: '112 bits',
                  value: '112 bits',
                  options: [
                    {
                      name: 'R1',
                      value: ALG_ECC_SECP112R1
                    },
                    {
                      name: 'R2',
                      value: ALG_ECC_SECP112R2
                    }
                  ]
                },
                {
                  name: '128 bits',
                  value: '128 bits',
                  options: [
                    {
                      name: 'R1',
                      value: ALG_ECC_SECP128R1
                    },
                    {
                      name: 'R2',
                      value: ALG_ECC_SECP128R2
                    }
                  ]
                },
                {
                  name: '160 bits',
                  value: '160 bits',
                  options: [
                    {
                      name: 'R1',
                      value: ALG_ECC_SECP160R1
                    },
                    {
                      name: 'R2',
                      value: ALG_ECC_SECP160R2
                    }
                  ]
                },
                {
                  name: '192 bits',
                  value: '192 bits',
                  options: [
                    {
                      name: 'R1',
                      value: ALG_ECC_SECP192R1
                    }
                  ]
                },
                {
                  name: '224 bits',
                  value: '224 bits',
                  options: [
                    {
                      name: 'R1',
                      value: ALG_ECC_SECP224R1
                    }
                  ]
                },
                {
                  name: '256 bits',
                  value: '256 bits',
                  options: [
                    {
                      name: 'R1',
                      value: ALG_ECC_SECP256R1
                    }
                  ]
                },
                {
                  name: '384 bits',
                  value: '384 bits',
                  options: [
                    {
                      name: 'R1',
                      value: ALG_ECC_SECP384R1
                    }
                  ]
                },
                {
                  name: '521 bits',
                  value: '521 bits',
                  options: [
                    {
                      name: 'R1',
                      value: ALG_ECC_SECP521R1
                    }
                  ]
                }
              ]
            },
            {
              name: 'SecG Koblitz',
              value: 'SecG Koblitz',
              options: [
                {
                  name: '160 bits',
                  value: '160 bits',
                  options: [
                    {
                      name: 'K1',
                      value: ALG_ECC_SECP160K1
                    }
                  ]
                },
                {
                  name: '192 bits',
                  value: '192 bits',
                  options: [
                    {
                      name: 'K1',
                      value: ALG_ECC_SECP192K1
                    }
                  ]
                },
                {
                  name: '224 bits',
                  value: '224 bits',
                  options: [
                    {
                      name: 'K1',
                      value: ALG_ECC_SECP224K1
                    }
                  ]
                },
                {
                  name: '256 bits',
                  value: '256 bits',
                  options: [
                    {
                      name: 'K1',
                      value: ALG_ECC_SECP256K1
                    }
                  ]
                }
              ]
            },
            {
              name: 'NIST Random',
              value: 'NIST Random',
              options: [
                {
                  name: '384 bits',
                  value: '384 bits',
                  options: [
                    {
                      name: 'R1',
                      value: ALG_ECC_SECP384R1
                    }
                  ]
                },
                {
                  name: '521 bits',
                  value: '521 bits',
                  options: [
                    {
                      name: 'R1',
                      value: ALG_ECC_SECP521R1
                    }
                  ]
                }
              ]
            },
            {
              name: 'ISO X9.62',
              value: 'ISO X9.62',
              options: [
                {
                  name: '192 bits',
                  value: '192 bits',
                  options: [
                    {
                      name: 'V1',
                      value: ALG_ECC_SECP192R1
                    },
                    {
                      name: 'V2',
                      value: ALG_ECC_X9_62_PRIME192V2
                    },
                    {
                      name: 'V3',
                      value: ALG_ECC_X9_62_PRIME192V3
                    }
                  ]
                },
                {
                  name: '239 bits',
                  value: '239 bits',
                  options: [
                    {
                      name: 'V1',
                      value: ALG_ECC_X9_62_PRIME239V1
                    },
                    {
                      name: 'V2',
                      value: ALG_ECC_X9_62_PRIME239V2
                    },
                    {
                      name: 'V3',
                      value: ALG_ECC_X9_62_PRIME239V3
                    }
                  ]
                },
                {
                  name: '256 bits',
                  value: '256 bits',
                  options: [
                    {
                      name: 'V1',
                      value: ALG_ECC_SECP256R1
                    }
                  ]
                }
              ]
            },
            {
              name: 'Brainpool',
              value: 'Brainpool',
              options: [
                {
                  name: '160 bits',
                  value: '160 bits',
                  options: [
                    {
                      name: 'Default',
                      value: ALG_ECC_BRAINPOOL_P160R1
                    },
                    {
                      name: 'Twisted',
                      value: ALG_ECC_BRAINPOOL_P160T1
                    }
                  ]
                },
                {
                  name: '192 bits',
                  value: '192 bits',
                  options: [
                    {
                      name: 'Default',
                      value: ALG_ECC_BRAINPOOL_P192R1
                    },
                    {
                      name: 'Twisted',
                      value: ALG_ECC_BRAINPOOL_P192T1
                    }
                  ]
                },
                {
                  name: '224 bits',
                  value: '224 bits',
                  options: [
                    {
                      name: 'Default',
                      value: ALG_ECC_BRAINPOOL_P224R1
                    },
                    {
                      name: 'Twisted',
                      value: ALG_ECC_BRAINPOOL_P224T1
                    }
                  ]
                },
                {
                  name: '256 bits',
                  value: '256 bits',
                  options: [
                    {
                      name: 'Default',
                      value: ALG_ECC_BRAINPOOL_P256R1
                    },
                    {
                      name: 'Twisted',
                      value: ALG_ECC_BRAINPOOL_P256T1
                    }
                  ]
                },
                {
                  name: '320 bits',
                  value: '320 bits',
                  options: [
                    {
                      name: 'Default',
                      value: ALG_ECC_BRAINPOOL_P320R1
                    },
                    {
                      name: 'Twisted',
                      value: ALG_ECC_BRAINPOOL_P320T1
                    }
                  ]
                },
                {
                  name: '384 bits',
                  value: '384 bits',
                  options: [
                    {
                      name: 'Default',
                      value: ALG_ECC_BRAINPOOL_P384R1
                    },
                    {
                      name: 'Twisted',
                      value: ALG_ECC_BRAINPOOL_P384T1
                    }
                  ]
                },
                {
                  name: '512 bits',
                  value: '512 bits',
                  options: [
                    {
                      name: 'Default',
                      value: ALG_ECC_BRAINPOOL_P512R1
                    },
                    {
                      name: 'Twisted',
                      value: ALG_ECC_BRAINPOOL_P512T1
                    }
                  ]
                }
              ]
            },
            {
              name: 'Edwards',
              value: 'Edwards',
              options: [
                {
                  name: '448 bits',
                  value: '448 bits',
                  options: [
                    {
                      name: 'Signature',
                      value: ALG_ECC_ED448
                    },
                    {
                      name: 'Key Exchange',
                      value: ALG_ECC_X448
                    }
                  ]
                },
                {
                  name: '256 bits',
                  value: '256 bits',
                  options: [
                    {
                      name: 'Signature',
                      value: ALG_ECC_ED25519
                    },
                    {
                      name: 'Key Exchange',
                      value: ALG_ECC_X25519
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      object: [
        {
          name: 'MAP',
          value: 'MAP'
        }
      ]
    }
  },
  getExportOptions: () => {
    return {
      symmetric: [
        {
          name: 'With KEK',
          value: 'With KEK'
        },
        {
          name: 'Key Components',
          value: 'Key Components'
        },
        {
          name: 'Clear Text Key',
          value: 'Clear Text Key'
        }
      ],
      asymmetric: [
        {
          name: 'PKCS#1',
          value: 'PKCS#1',
          options: [
            {
              name: 'Private key',
              value: 'Private key'
            },
            {
              name: 'Public key',
              value: 'Public key'
            },
            {
              name: 'Public key (X.509)',
              value: 'Public key (X.509)'
            }
          ]
        },
        {
          name: 'PKCS#8',
          value: 'PKCS#8'
        },
        {
          name: 'PKCS#12',
          value: 'PKCS#12'
        },
        {
          name: 'With KEK',
          value: 'With KEK'
        }
        // ,
        // {
        //   name: 'EMV CSR',
        //   value: 'EMV CSR'
        // }
      ],
      others: [
        {
          name: 'File',
          value: 'File'
        },
        {
          name: 'Certificate',
          value: 'Certificate',
          options: [
            {
              name: 'Clear Text Key',
              value: 'Clear Text Key'
            },
            {
              name: 'PKCS#12',
              value: 'PKCS#12'
            }
          ]
        },
        {
          name: 'PKCS#7',
          value: 'PKCS#7'
        }
      ]
    }
  },
  getSP80057State: state => ({ st }) => {
    if (!Object.prototype.hasOwnProperty.call(state.SL_STATE_MAPPER, st)) {
      return st
    }
    return state.SL_STATE_MAPPER[st]
  },
  getKeyType: state => ({ type }) => {
    if (!Object.prototype.hasOwnProperty.call(state.SL_ALG_MAPPER, type)) {
      return type
    }
    return state.SL_ALG_MAPPER[type]
  },
  getItemFamilyType: () => ({ type }) => {
    if (familyOthers.includes(type)) {
      return 'others'
    }

    for (const range of asymmetricRanges) {
      if (type >= range[0] && type <= range[1]) {
        return 'asymmetric'
      }
    }
    return 'symmetric'
  },
  getNeedsCSRP10: (state, getters) => ({ type }) => {
    const algFamily = getters.getItemFamilyType({ type })
    return (
      algFamily === 'asymmetric' &&
      type !== ALG_ECC_X448 &&
      type !== ALG_ECC_X25519 &&
      type !== ALG_OBJ_PUBKEY_RSA_BLOB
    )
  }
}

export const mutations = {
  SET_META_NAME (state, payload = null) {
    state.meta.name = payload
  },
  SET_META_ATTR (state, payload = 0) {
    state.meta.attr = payload
  },
  SET_META_TYPE (state, payload = null) {
    state.meta.type = payload
  },
  SET_CURRENT_NAME (state, payload = null) {
    state.currentName = payload
  },
  SET_BLOCKED (state, payload = false) {
    state.blocked = payload
  },
  SET_CKA_OBJECT_ID (state, payload = null) {
    state.CKA_OBJECT_ID = payload
  },
  SET_CKA_ID (state, payload = null) {
    state.CKA_ID = payload
  },
  SET_CKA_LABEL (state, payload = null) {
    state.CKA_LABEL = payload
  },
  SET_CKA_APPLICATION (state, payload = null) {
    state.CKA_APPLICATION = payload
  },
  SET_CKA_JMIDP_SEC_DOMAIN (state, payload = null) {
    state.CKA_JMIDP_SEC_DOMAIN = payload
  },
  SET_CKA_CERT_CATEGORY (state, payload = null) {
    state.CKA_CERT_CATEGORY = payload
  },
  SET_CKA_KEY_GEN_MECHANISM (state, payload = null) {
    state.CKA_KEY_GEN_MECHANISM = payload
  },
  SET_HSM_ASSOCIATE (state, payload = null) {
    state.HSM_ASSOCIATE = payload
  },
  SET_HSM_OBJ_PVALUE (state, payload = null) {
    state.HSM_OBJ_PVALUE = payload
  },
  SET_CKA_SUBJECT (state, payload = null) {
    state.CKA_SUBJECT = payload
  },
  SET_CKA_DERIVE (state, payload = false) {
    state.CKA_DERIVE = payload
  },
  SET_CKA_WRAP (state, payload = false) {
    state.CKA_WRAP = payload
  },
  SET_CKA_UNWRAP (state, payload = false) {
    state.CKA_UNWRAP = payload
  },
  SET_CKA_SIGN (state, payload = false) {
    state.CKA_SIGN = payload
  },
  SET_CKA_VERIFY (state, payload = false) {
    state.CKA_VERIFY = payload
  },
  SET_CKA_ENCRYPT (state, payload = false) {
    state.CKA_ENCRYPT = payload
  },
  SET_CKA_DECRYPT (state, payload = false) {
    state.CKA_DECRYPT = payload
  },
  SET_CKA_SIGN_RECOVER (state, payload = false) {
    state.CKA_SIGN_RECOVER = payload
  },
  SET_CKA_TRUSTED (state, payload = false) {
    state.CKA_TRUSTED = payload
  },
  SET_CKA_WRAP_WITH_TRUSTED (state, payload = false) {
    state.CKA_WRAP_WITH_TRUSTED = payload
  },
  SET_CKA_VERIFY_RECOVER (state, payload = false) {
    state.CKA_VERIFY_RECOVER = payload
  },
  RESET (state) {
    state.meta.name = null
    state.meta.attr = 0
    state.meta.type = null

    state.currentName = null
    state.blocked = false
    state.CKA_DERIVE = false
    state.CKA_WRAP = false
    state.CKA_UNWRAP = false
    state.CKA_SIGN = false
    state.CKA_VERIFY = false
    state.CKA_ENCRYPT = false
    state.CKA_DECRYPT = false
    state.CKA_SIGN_RECOVER = false
    state.CKA_VERIFY_RECOVER = false
    state.CKA_TRUSTED = false
    state.CKA_WRAP_WITH_TRUSTED = false

    state.CKA_SUBJECT = null

    state.CKA_OBJECT_ID = null
    state.CKA_ID = null
    state.CKA_LABEL = null
    state.CKA_APPLICATION = null
    state.CKA_JMIDP_SEC_DOMAIN = null
    state.CKA_CERT_CATEGORY = null
    state.CKA_KEY_GEN_MECHANISM = null
    state.HSM_ASSOCIATE = null
    state.HSM_OBJ_PVALUE = null
  }
}

export const actions = {
  async createKey ({ state, rootState, dispatch }) {
    const hsm = rootState.hsm.instance
    const body = {
      obj: state.meta.name,
      type: state.meta.type,
      attr: state.meta.attr
    }

    try {
      await hsm.createKey({ body })
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async deleteKey ({ rootState, dispatch }, { name }) {
    const hsm = rootState.hsm.instance
    const body = {
      obj: name
    }

    try {
      await hsm.delObject({ body })
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async createMap ({ rootState, dispatch }, { slot1, slot2, name }) {
    const hsm = rootState.hsm.instance

    const body = {
      obj: name,
      obj1: slot1,
      type1: null,
      obj2: slot2,
      type2: null
    }

    const slot1Info = await dispatch('getKeyInfo', { obj: slot1 })
    const slot2Info = await dispatch('getKeyInfo', { obj: slot2 })
    body.type1 = slot1Info.type
    body.type2 = slot2Info.type

    try {
      await hsm.newMap({ body })
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async exportKey ({ rootState, dispatch }, { obj }) {
    const hsm = rootState.hsm.instance
    const body = {
      obj
    }

    try {
      const res = await hsm.exportObject(body)
      return res
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async importKey ({ rootState, dispatch }, { type, attr, obj, mat }) {
    const hsm = rootState.hsm.instance
    const body = {
      obj,
      type,
      attr,
      mat
    }

    const OBJ_HEX = sha256(body.mat)

    body.mat = OBJ_HEX

    try {
      await hsm.importKey(body)
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async importP12 (
    { rootState, dispatch },
    { key, pbk, cert, pwd = '', attr = 1, pfx }
  ) {
    const hsm = rootState.hsm.instance
    const body = {
      key,
      pbk,
      cert,
      pwd,
      attr,
      pfx
    }

    // const OBJ_HEX = sha256(body.mat)

    // body.mat = OBJ_HEX

    try {
      await hsm.importP12(body)
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async getListKeys ({ dispatch, getters, rootState }) {
    try {
      const res = await rootState.hsm.instance.getKeys()
      // getters.setKeyAndTypeList(res)
      return res
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async getKeyInfo ({ dispatch, rootState }, { obj }) {
    try {
      const res = await rootState.hsm.instance.getObjectInfo({ body: { obj } })
      return res
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async getKeySP80057 ({ dispatch, rootState }, { obj }) {
    try {
      const res = await rootState.hsm.instance.getObjectSP80057({
        body: { obj }
      })
      return res
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async getP11Manager ({ dispatch, rootState }, { obj }) {
    const body = {
      obj
    }
    try {
      const res = await rootState.hsm.instance.p11ManagerGet({ body })
      return res
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async getMapInfo ({ dispatch, rootState }, { obj }) {
    try {
      const res = await rootState.hsm.instance.getMapInfo({ body: { obj } })
      return res
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async updateP11Manager ({ state, rootState, dispatch }, { obj }) {
    const hsm = rootState.hsm.instance
    const myAttr = {
      CKA_DERIVE: state.CKA_DERIVE,
      CKA_WRAP: state.CKA_WRAP,
      CKA_UNWRAP: state.CKA_UNWRAP,
      CKA_SIGN: state.CKA_SIGN,
      CKA_VERIFY: state.CKA_VERIFY,
      CKA_ENCRYPT: state.CKA_ENCRYPT,
      CKA_DECRYPT: state.CKA_DECRYPT,
      CKA_SIGN_RECOVER: state.CKA_SIGN_RECOVER,
      CKA_VERIFY_RECOVER: state.CKA_VERIFY_RECOVER,
      CKA_TRUSTED: state.CKA_TRUSTED,
      CKA_WRAP_WITH_TRUSTED: state.CKA_WRAP_WITH_TRUSTED,

      CKA_SUBJECT: state.CKA_SUBJECT,

      CKA_OBJECT_ID: state.CKA_OBJECT_ID,
      CKA_ID: state.CKA_ID,
      CKA_LABEL: state.CKA_LABEL,
      CKA_APPLICATION: state.CKA_APPLICATION,
      CKA_JMIDP_SEC_DOMAIN: state.CKA_JMIDP_SEC_DOMAIN,
      CKA_CERT_CATEGORY: state.CKA_CERT_CATEGORY,
      CKA_KEY_GEN_MECHANISM: state.CKA_KEY_GEN_MECHANISM,
      HSM_ASSOCIATE: state.HSM_ASSOCIATE,
      HSM_OBJ_PVALUE: state.HSM_OBJ_PVALUE
    }
    const body = {
      obj,
      attrs: myAttr
    }
    try {
      const res = await hsm.p11ManagerUpdate({ body })
      return res
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async setObjBlockedState ({ state, dispatch, rootState }, { obj }) {
    let op
    if (state.blocked) {
      op = MSBO_OP_BLOCK
    } else {
      op = MSBO_OP_UNBLOCK
    }
    const body = {
      obj,
      op
    }
    try {
      const res = await rootState.hsm.instance.blockObject({ body })
      return res
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async objIsBlocked ({ commit, dispatch, rootState }, { obj }) {
    const body = {
      obj,
      op: MSBO_OP_STATUS
    }
    try {
      const res = await rootState.hsm.instance.blockObject({ body })
      const result = res.status === MSBO_OP_BLOCK
      commit('SET_BLOCKED', result)
      return result
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  // USAGE:
  // this.$store.dispatch('keys/deleteAllKeys')
  // .then(() => {
  //   console.log('all keys were deleted')
  // })
  // REMEBER TO REMOVE AFTER USING IT
  async deleteAllKeys ({ dispatch, rootState }) {
    let keysArray
    await dispatch('getListKeys').then(res => {
      keysArray = res
    })
    keysArray.forEach(key => {
      dispatch('deleteKey', { name: key })
    })
  },

  async renameObj ({ dispatch, rootState }) {
    const body = {
      src: state.currentName,
      dst: state.meta.name
    }
    try {
      await rootState.hsm.instance.renameObj({ body })
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  }
}
